import { useMutation } from '@tanstack/react-query'

import { updateMerchantOrganizationComment } from '@src/api'
import { DefaultApiUpdateMerchantOrganizationCommentRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateMerchantOrganizationComment = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: (params: DefaultApiUpdateMerchantOrganizationCommentRequest) =>
      updateMerchantOrganizationComment(axiosInstance, params),
  })
}
